import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';

import { Heading } from '../../components';

import css from './ListingPage.module.css';

const { Money } = sdkTypes;

const SectionRentalConditions = props => {
  const { publicData = {}, intl } = props;

  if ( !publicData ) {
    return null;
  }

  const {
    categoryLevel1,
    minimumNights, minimumAge, freeKilometers, extrakilometers, deposit,
    petsAllowed, smokingAllowed, foreignTravelsAllowed, festivalsAllowed,
  } = publicData;

  const allowedOptions = [], notAllowedOptions = [], negotiableOptions = [];

  const petsAllowedFlag = Array.isArray( petsAllowed ) && petsAllowed.length > 0
    ? petsAllowed[ 0 ] : 'negotiable';
  const petsDetailClass = petsAllowedFlag === 'no'
    ? css.detailNotAllowedLabel
    : petsAllowedFlag === 'yes'
      ? css.detailAllowedLabel
      : css.detailNegotiableLabel;
  const petsOption = (
    <li key="petsAllowed" className={css.detailsRow}>
      <span className={petsDetailClass}>
        { petsAllowedFlag === 'no' ? (
          <FormattedMessage id="ListingPage.rentalConditionsNoPetsAllowedLabel" />
        ) : petsAllowedFlag === 'yes' ? (
          <FormattedMessage id="ListingPage.rentalConditionsPetsAreAllowedLabel" />
        ) : (
          <FormattedMessage id="ListingPage.rentalConditionsPetsAreNegotiableLabel" />
        )}
      </span>
    </li>
  );

  if( petsAllowedFlag === 'no') {
    notAllowedOptions.push(petsOption);
  } else if( petsAllowedFlag === 'yes') {
    allowedOptions.push(petsOption);
  } else {
    negotiableOptions.push(petsOption);
  }

  const smokingAllowedFlag = Array.isArray( smokingAllowed ) && smokingAllowed.length > 0
    ? smokingAllowed[ 0 ] : 'negotiable';
  const smokingDetailClass = smokingAllowedFlag === 'no'
    ? css.detailNotAllowedLabel
    : smokingAllowedFlag === 'yes'
      ? css.detailAllowedLabel
      : css.detailNegotiableLabel;
  const smokingOption = (
    <li key="smokingAllowed" className={css.detailsRow}>
      <span className={smokingDetailClass}>
        { smokingAllowedFlag === 'no' ? (
          <FormattedMessage id="ListingPage.rentalConditionsNoSmokingAllowedLabel" />
        ) : smokingAllowedFlag === 'yes' ? (
          <FormattedMessage id="ListingPage.rentalConditionsSmokingIsAllowedLabel" />
        ) : (
          <FormattedMessage id="ListingPage.rentalConditionsSmokingIsNegotiableLabel" />
        )}
      </span>
    </li>
  );

  if( smokingAllowedFlag === 'no') {
    notAllowedOptions.push(smokingOption);
  } else if( smokingAllowedFlag === 'yes') {
    allowedOptions.push(smokingOption);
  } else {
    negotiableOptions.push(smokingOption);
  }

  const foreignTravelsAllowedFlag = Array.isArray( foreignTravelsAllowed ) && foreignTravelsAllowed.length > 0
    ? foreignTravelsAllowed[ 0 ] : 'negotiable';
  const foreignTravelsDetailClass = foreignTravelsAllowedFlag === 'no'
    ? css.detailNotAllowedLabel
    : foreignTravelsAllowedFlag === 'yes'
      ? css.detailAllowedLabel
      : css.detailNegotiableLabel;
  const foreignTravelsOption = (
    <li key="foreignTravelsAllowed" className={css.detailsRow}>
      <span className={foreignTravelsDetailClass}>
        { foreignTravelsAllowedFlag === 'no' ? (
          <FormattedMessage id="ListingPage.rentalConditionsNoForeignTravelsAllowedLabel" />
        ) : foreignTravelsAllowedFlag === 'yes' ? (
          <FormattedMessage id="ListingPage.rentalConditionsForeignTravelsAreAllowedLabel" />
        ) : (
          <FormattedMessage id="ListingPage.rentalConditionsForeignTravelsAreNegotiableLabel" />
        )}
      </span>
    </li>
  );

  if( foreignTravelsAllowedFlag === 'no') {
    notAllowedOptions.push(foreignTravelsOption);
  } else if( foreignTravelsAllowedFlag === 'yes') {
    allowedOptions.push(foreignTravelsOption);
  } else {
    negotiableOptions.push(foreignTravelsOption);
  }

  const festivalsAllowedFlag = Array.isArray( festivalsAllowed ) && festivalsAllowed.length > 0
    ? festivalsAllowed[ 0 ] : 'negotiable';
  const festivalsDetailClass = festivalsAllowedFlag === 'no'
    ? css.detailNotAllowedLabel
    : festivalsAllowedFlag === 'yes'
      ? css.detailAllowedLabel
      : css.detailNegotiableLabel;
  const festivalsOption = (
    <li key="festivalsAllowed" className={css.detailsRow}>
      <span className={festivalsDetailClass}>
        { festivalsAllowedFlag === 'no' ? (
          <FormattedMessage id="ListingPage.rentalConditionsNoFestivalsAllowedLabel" />
        ) : festivalsAllowedFlag === 'yes' ? (
          <FormattedMessage id="ListingPage.rentalConditionsFestivalsAreAllowedLabel" />
        ) : (
          <FormattedMessage id="ListingPage.rentalConditionsFestivalsAreNegotiableLabel" />
        )}
      </span>
    </li>
  );

  if( festivalsAllowedFlag === 'no') {
    notAllowedOptions.push(festivalsOption);
  } else if( festivalsAllowedFlag === 'yes') {
    allowedOptions.push(festivalsOption);
  } else {
    negotiableOptions.push(festivalsOption);
  }

  return (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.rentalConditionsTitle" />
      </Heading>
      <ul className={css.details}>
        { minimumNights ? (
          <li key="minimumNights" className={css.detailsRow}>
          <span className={css.detailLabel}>
            <FormattedMessage id="ListingPage.rentalConditionsMinimumNightsLabel" />
          </span>
            <span>{minimumNights}</span>
          </li>
        ) : null }
        { minimumAge ? (
          <li key="minimumAge" className={css.detailsRow}>
          <span className={css.detailLabel}>
            <FormattedMessage id="ListingPage.rentalConditionsMinimumAgeLabel" />
          </span>
            <span>{minimumAge}</span>
          </li>
        ) : null }
        { freeKilometers && categoryLevel1 === 'camper-huren' ? (
          <li key="freeKilometers" className={css.detailsRow}>
          <span className={css.detailLabel}>
            <FormattedMessage id="ListingPage.rentalConditionsFreeKilometersLabel" />
          </span>
            <span>{freeKilometers}</span>
          </li>
        ) : null }
        { extrakilometers ? (
          <li key="extrakilometers" className={css.detailsRow}>
          <span className={css.detailLabel}>
            <FormattedMessage id="ListingPage.rentalConditionsExtraKilometersLabel" />
          </span>
            <span>{extrakilometers}</span>
          </li>
        ) : null }
        { deposit ? (
          <li key="deposit" className={css.detailsRow}>
          <span className={css.detailLabel}>
            <FormattedMessage id="ListingPage.rentalConditionsDepositAmountLabel" />
          </span>
            <span>{ formatMoney( intl, new Money( deposit, 'EUR'))}</span>
          </li>
        ) : null }
        {allowedOptions}
        {notAllowedOptions}
        {negotiableOptions}
      </ul>
    </section>
  );
};

export default SectionRentalConditions;
